'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPrint, iconPrintTag } from '@ni/nimble-components/dist/esm/icons/print';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPrint };
export { iconPrintTag };
export const NimbleIconPrint = wrap(IconPrint);